  import React, { useRef, useState, useEffect } from "react";
  import {
    Box,
    Button,
    Checkbox,
    Container,
    FormControl,
    FormControlLabel,
    Paper,
    TextField,
    Typography,
    Tabs,
    Tab,
    ThemeProvider,
    createTheme,
    CssBaseline,
    IconButton,
    InputAdornment,
    Snackbar,
    Alert,
    CircularProgress,
    MenuItem,
  } from "@mui/material";
  import DeleteIcon from "@mui/icons-material/Delete";
  import VisibilityIcon from "@mui/icons-material/Visibility";
  import SignatureCanvas from "react-signature-canvas";
  import bg from "../img/splashSceen.png";
  import companylogo from "../img/red with white bck.png";
  import { base_url } from "../api/api-url";
  import { useParams } from "react-router-dom";
  import axios from "axios";
  import { getRegisterVendor } from "../store/features/vendors/vendorApi";
  import { set } from "date-fns";

  const localTheme = createTheme({
    palette: {
      primary: { main: "#c60800" },
      secondary: { main: "#c60800" },
    },
  });

  export default function VendorRegistrationForm() {
    const sigCanvas = useRef(null);
    // Access vendorId from URL
    const { vendorId } = useParams();

    const [signature, setSignature] = useState(null);
    const [signatureMode, setSignatureMode] = useState("draw");
    const [typedSignature, setTypedSignature] = useState("");
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "info",
    });
    const [isSuccess, setIsSuccess] = useState(false);
    const [otherService, setOtherService] = useState("");

    const [formData, setFormData] = useState({
      cateringName: "",
      firstName: "",
      lastName: "",
      designation: "",
      mobile: "",
      altMobile: "",
      email: "",
      street: "",
      address2: "",
      city: "",
      state: "",
      pin: "",
      website: "",
      branches: "",
      fssai: "",
      pan: "",
      gst: "",
      referralFirst: "",
      referralLast: "",
      qhscauditor: "",
      interestedServices: [],
    });

    const [fssaiFile, setFssaiFile] = useState(null);
    const [kitchenImages, setKitchenImages] = useState([]);
    const [menuFile, setMenuFile] = useState(null);

    // ---------- Resize Signature Canvas ----------
    useEffect(() => {
      const resizeCanvas = () => {
        if (sigCanvas.current) {
          const canvas = sigCanvas.current.getCanvas();
          const parent = canvas.parentNode;
          canvas.width = parent.offsetWidth;
          canvas.height = 180;
          const ctx = canvas.getContext("2d");
          ctx.setTransform(1, 0, 0, 1, 0, 0);
        }
      };
      resizeCanvas();
      window.addEventListener("resize", resizeCanvas);
      return () => window.removeEventListener("resize", resizeCanvas);
    }, []);

    const handleSignatureEnd = () => {
      if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
        const dataURL = sigCanvas.current.getCanvas().toDataURL("image/png");
        setSignature(dataURL);
      }
    };

    useEffect(() => {
      const fetchVendorData = async () => {
        if (vendorId) {
          try {
            const res = await getRegisterVendor(vendorId); // Await the async call
            console.log("Vendor Data:", res); // Log the response
            if (res?.data?.data) {
              setFormData(res.data.data); // Set the form data if it exists
              setFssaiFile(res.data.data.fssaiCertificateUrl || null);
              setKitchenImages(res.data.data.kitchenImages || []);
              setMenuFile(res.data.data.menuListUrl || null);
            }
          } catch (error) {
            console.error("Error fetching vendor data:", error); // Handle any errors
          }
        }
      };

      fetchVendorData(); // Call the async function inside useEffect
    }, [vendorId]); // Ensure the effect runs when vendorId changes

    useEffect(() => {
      if (signatureMode === "draw" && sigCanvas.current) {
        const canvas = sigCanvas.current.getCanvas();
        const parent = canvas.parentNode;
        canvas.width = parent.offsetWidth;
        canvas.height = 180;
        const ctx = canvas.getContext("2d");
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        sigCanvas.current.clear();
      }
    }, [signatureMode]);

    useEffect(() => {
      if (signatureMode === "type" && typedSignature.trim()) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = 400;
        canvas.height = 100;
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.font = "28px cursive";
        ctx.fillStyle = "black";
        ctx.fillText(typedSignature, 50, 60);
        setSignature(canvas.toDataURL("image/png"));
      }
    }, [typedSignature, signatureMode]);

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      // Allow only digits for mobile and person contact numbers
      if (
        ["mobile", "altMobile"].includes(name) ||
        (name.startsWith("person") && name.endsWith("_number"))
      ) {
        if (!/^\d*$/.test(value)) return;
        if (value.length > 10) return;
      }
      if (name === "pin") {
        if (!/^\d*$/.test(value)) return;
        if (value.length > 6) return;
      }
      setFormData({ ...formData, [name]: value });
    };

    const showSnackbar = (message, severity = "info") => {
      setSnackbar({ open: true, message, severity });
    };

    // ---------- File Validation (Allow Images & PDF) ----------
    // ---------- File Validation ----------
    const validateFile = (file, type) => {
      const imageTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
      const pdfType = ["application/pdf"];

      // ✅ FSSAI can be image OR PDF
      if (type === "fssai") {
        if (![...imageTypes, ...pdfType].includes(file.type)) {
          showSnackbar(
            "Only image or PDF files are allowed for FSSAI Certificate.",
            "error",
          );
          return false;
        }
      } else {
        // ✅ Kitchen Images & Menu — only images
        if (!imageTypes.includes(file.type)) {
          showSnackbar(
            "Only image files (JPG, JPEG, PNG, WEBP) are allowed.",
            "error",
          );
          return false;
        }
      }

      // ✅ Size limit
      if (file.size > 2 * 1024 * 1024) {
        showSnackbar("File size must be less than 2 MB.", "error");
        return false;
      }

      return true;
    };

    const handleFssaiUpload = (e) => {
      const file = e.target.files[0];
      if (file && !validateFile(file, "fssai")) return;
      setFssaiFile(file);
    };

    const handleKitchenImagesUpload = (e) => {
      const files = Array.from(e.target.files);
      if (kitchenImages.length + files.length > 3) {
        showSnackbar("You can upload a maximum of 3 kitchen images.", "error");
        return;
      }
      const validFiles = files.filter((f) => validateFile(f, "kitchen"));
      setKitchenImages([...kitchenImages, ...validFiles]);
    };

    const handleMenuUpload = (e) => {
      const file = e.target.files[0];
      if (file && !validateFile(file, "menu")) return;
      setMenuFile(file);
    };

    const removeKitchenImage = (index) =>
      setKitchenImages(kitchenImages.filter((_, i) => i !== index));

    const clearSignature = () => {
      if (sigCanvas.current) sigCanvas.current.clear();
      setSignature(null);
      setTypedSignature("");
    };

    // ---------- Validation ---------     
    const fieldLabels = {
      cateringName: "Catering Name",
      firstName: "First Name",
      mobile: "Mobile Number",
      designation: "Designation",
      email: "Email",
      street: "Kitchen Address",
      city: "City",
      state: "State",
      pin: "PIN Code",
      fssai: "FSSAI License No",
      gst: "GST Number",
      referralFirst: "Referral Person Name",
      qhscauditor: "QHSC Auditor Name",
      person1_name: "Person 1 Name",
      person1_number: "Person 1 Number",
      person1_designation: "Person 1 Designation",
      person2_name: "Person 2 Name",
      person2_number: "Person 2 Number",
      person2_designation: "Person 2 Designation",
      person3_name: "Person 3 Name",
      person3_number: "Person 3 Number",
      person3_designation: "Person 3 Designation",
      person4_name: "Person 4 Name",
      person4_number: "Person 4 Number",
      person4_designation: "Person 4 Designation",
      person5_name: "Person 5 Name",
      person5_number: "Person 5 Number",
      person5_designation: "Person 5 Designation",
    };

    console.log(Boolean(fssaiFile));
    const validateForm = () => {
      // Base required fields + dynamic person fields
      const requiredFields = [
        "cateringName",
        "firstName",
        "designation",
        "mobile",
        "email",
        "street",
        "city",
        "state",
        "pin",
        "fssai",
        "referralFirst",
        "qhscauditor",
        // "gst",

        // 👇 dynamically add person1–person5 fields
        ...Array.from({ length: 5 }).flatMap((_, i) => {
          const index = i + 1;
          return [
            `person${index}_name`,
            `person${index}_number`,
            `person${index}_designation`,
          ];
        }),
      ];

      const missing = requiredFields.filter((f) => !formData[f]?.trim());
      if (missing.length > 0) {
        const readable = missing.map((f) => fieldLabels[f] || f).join(", ");
        showSnackbar(`Please fill these required fields: ${readable}`, "error");
        return false;
      }
      if (!Boolean(fssaiFile)) {
        showSnackbar(`Please upload FSSAI Certificate`, "error");
        return false;
      }
      if (formData.fssai && formData.fssai.length < 14) {
        showSnackbar("FSSAI License Number must be at least 14 digits.", "error");
        return false;
      }

      if (formData.pan && !/^[A-Z0-9]{10}$/i.test(formData.pan)) {
        showSnackbar(
          "Invalid PAN format. Must be 10 alphanumeric characters.",
          "error",
        );
        return false;
      }

      if (formData.gst && !/^[A-Z0-9]{15}$/i.test(formData.gst)) {
        showSnackbar(
          "Invalid GST format. Must be 15 alphanumeric characters.",
          "error",
        );
        return false;
      }

      if (!vendorId && !signature) {
        showSnackbar("Please provide your signature.", "error");
        return false;
      }

      return true;
    };
    const uploadFileToS3 = async (file) => {
      try {
        const data = new FormData();
        data.append("file", file);

        const res = await fetch(`${base_url}/upload`, {
          method: "POST",
          body: data,
        });

        const result = await res.json();
        if (result.success) {
          return result.data.url; // return the S3 URL
        } else {
          showSnackbar(result.message || "File upload failed", "error");
          return null;
        }
      } catch (err) {
        console.error("Upload error:", err);
        showSnackbar("Error uploading file", "error");
        return null;
      }
    };

    // ---------- Submit ----------
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) return;

      try {
        setLoading(true);

        // ---- 1. Upload files individually ----
        let fssaiUrl = null;
        let menuUrl = null;
        let kitchenUrls = [];
        let signatureUrl = null;

        if (fssaiFile) fssaiUrl = await uploadFileToS3(fssaiFile);
        if (menuFile) menuUrl = await uploadFileToS3(menuFile);
        for (const img of kitchenImages) {
          const url = await uploadFileToS3(img);
          if (url) kitchenUrls.push(url);
        }

        // Upload signature
        if (signature) {
          const sigBlob = await (await fetch(signature)).blob();
          const sigFile = new File([sigBlob], "signature.png", {
            type: "image/png",
          });
          signatureUrl = await uploadFileToS3(sigFile);
        }

        // ---- 2. Build final payload (no files, only URLs) ----
        const formCopy = { ...formData };

        if (formCopy.interestedServices.includes("OTHERS")) {
          formCopy.interestedServices = formCopy.interestedServices.filter(
            (s) => s !== "OTHERS",
          );
          if (otherService.trim()) {
            formCopy.interestedServices.push(otherService.trim());
          }
        }

        const payload = {
          ...formCopy,
          fssaiCertificateUrl: fssaiUrl,
          kitchenImages: kitchenUrls,
          menuListUrl: menuUrl,
          signatureUrl,
        };

        if (vendorId) {
          await handleVendorUpdate(payload, vendorId);
          return;
        }
        // ---- 3. Submit to backend ----
        const res = await fetch(`${base_url}/vendor/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const result = await res.json();
        if (result.success) {
          showSnackbar("Vendor Registered Successfully!", "success");
          setTimeout(() => setIsSuccess(true), 1200);
        } else {
          showSnackbar(result.message || "Failed to register.", "error");
        }
      } catch (err) {
        console.error(err);
        showSnackbar("Error submitting form!", "error");
      } finally {
        setLoading(false);
      }
    };

    const handleVendorUpdate = async (payload, vendorId) => {
      setLoading(true);
      try {
        // Make the API call using fetch
        const res = await fetch(`${base_url}/registervendor/${vendorId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload), // Send the payload as JSON
        });

        const result = await res.json();

        // Check if the update was successful
        if (result.success) {
          showSnackbar("Vendor Updated Successfully!", "success");
          setTimeout(() => setIsSuccess(true), 1200);
        } else {
          showSnackbar(result.message || "Failed to update vendor.", "error");
        }
      } catch (err) {
        console.error("Error updating vendor:", err);
        showSnackbar("Error updating vendor!", "error");
      } finally {
        setLoading(false);
      }
    };

    console.log(formData);
    const indianStates = [
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chhattisgarh",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal",
    ];

    // ---------- Success Page ----------
    if (isSuccess) {
      return (
        <ThemeProvider theme={localTheme}>
          <CssBaseline />
          <Box
            sx={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
            }}
          >
            <Paper sx={{ p: 5, borderRadius: 3 }}>
              <Box
                component="img"
                src={companylogo}
                alt="logo"
                sx={{ width: 180, mb: 2 }}
              />
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                🎉 Registration Successful!
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Thank you for registering with HOGIST. Our team will review your
                details and contact you shortly.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.reload()}
              >
                Go Back to Home
              </Button>
            </Paper>
          </Box>
        </ThemeProvider>
      );
    }

    // ---------- Main Form ----------
    return (
      <ThemeProvider theme={localTheme}>
        <CssBaseline />
        <Box
          sx={{
            backgroundImage: `url(${bg})`,
            backgroundSize: "fit",
            backgroundPosition: "center",
            minHeight: "100vh",
            py: 5,
          }}
        >
          <Container maxWidth="md">
            <Paper elevation={4} sx={{ p: 4, mt: 5, borderRadius: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={companylogo}
                  alt="logo"
                  sx={{ width: 200, mb: 1 }}
                />
              </Box>

              <Typography
                variant="h5"
                align="center"
                fontWeight="bold"
                gutterBottom
              >
                VENDOR SELF - REGISTRATION PORTAL
              </Typography>

              {/* --------------- FORM START --------------- */}
              <Box component="form" onSubmit={handleSubmit}>
                {/* Catering Name */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Name of Catering Service / Restaurant / Cloud Kitchen{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="cateringName"
                    value={formData.cateringName}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Enter name"
                    fullWidth
                  />
                </FormControl>

                {/* Contact Person */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Contact Person Details <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      size="small"
                      fullWidth
                      placeholder="First Name"
                    />

                    <TextField
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      size="small"
                      fullWidth
                      placeholder="Last Name"
                    />
                  </Box>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Designation
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="designation"
                    value={formData.designation}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Enter designation"
                    fullWidth
                  />
                </FormControl>
                {/* Mobile */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Mobile Number <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    size="small"
                    fullWidth
                    placeholder="Enter 10-digit mobile"
                    inputProps={{ inputMode: "numeric", maxLength: 10 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              pr: 1,
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            <img
                              src="https://flagcdn.com/w20/in.png"
                              alt="India flag"
                              style={{
                                width: 20,
                                height: 15,
                                borderRadius: "2px",
                              }}
                            />
                            <Typography sx={{ fontSize: "14px" }}>+91</Typography>
                          </Box>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                {/* Alternate Mobile */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Alternate Mobile Number
                  </Typography>
                  <TextField
                    name="altMobile"
                    value={formData.altMobile}
                    onChange={handleInputChange}
                    size="small"
                    fullWidth
                    placeholder="Alternate mobile number"
                    inputProps={{ inputMode: "numeric", maxLength: 10 }}
                  />
                </FormControl>
                <Typography variant="subtitle2" sx={{ mt: 2 }}>
                  Alternate Contact Details{" "}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                {Array.from({ length: 5 }).map((_, index) => {
                  const personIndex = index + 1; // makes it 1-based (1 to 5)

                  return (
                    <Box
                      key={`person-row-${personIndex}`}
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" }, // ✅ stack vertically on mobile
                        gap: 2,
                        width: "100%",
                        mt: personIndex > 1 ? 2 : 0,
                      }}
                    >
                      {/* Person Name */}
                      <FormControl fullWidth>
                        <TextField
                          name={`person${personIndex}_name`}
                          value={formData[`person${personIndex}_name`] || ""}
                          onChange={handleInputChange}
                          size="small"
                          placeholder="Name"
                          inputProps={{ maxLength: 50 }}
                        />
                      </FormControl>

                      {/* Person Number */}
                      <FormControl fullWidth>
                        <TextField
                          name={`person${personIndex}_number`}
                          value={formData[`person${personIndex}_number`] || ""}
                          onChange={handleInputChange}
                          size="small"
                          placeholder="Contact number"
                          type="tel"
                          inputProps={{ inputMode: "numeric", maxLength: 10 }}
                        />
                      </FormControl>

                      {/* Person Designation */}
                      <FormControl fullWidth>
                        <TextField
                          name={`person${personIndex}_designation`}
                          value={
                            formData[`person${personIndex}_designation`] || ""
                          }
                          onChange={handleInputChange}
                          size="small"
                          placeholder="Designation"
                          inputProps={{ maxLength: 50 }}
                        />
                      </FormControl>
                    </Box>
                  );
                })}

                {/* Email */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Official Email Address <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    type="email"
                    size="small"
                    fullWidth
                    placeholder="Enter email"
                  />
                </FormControl>

                {/* Address */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Kitchen Address <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="street"
                    value={formData.street}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Street Address"
                    fullWidth
                    sx={{ mb: 1 }}
                  />
                  <TextField
                    name="address2"
                    value={formData.address2}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Address Line 2"
                    fullWidth
                    sx={{ mb: 1 }}
                  />
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      size="small"
                      placeholder="City"
                      fullWidth
                    />
                    <TextField
                      select
                      name="state"
                      label={formData.state === "" ? "Select state" : ""}
                      value={formData.state}
                      onChange={handleInputChange}
                      size="small"
                      fullWidth
                    >
                      <MenuItem disabled value="">
                        <em>Select the state</em>
                      </MenuItem>
                      {indianStates.map((s) => (
                        <MenuItem key={s} value={s}>
                          {s}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                  <TextField
                    name="pin"
                    value={formData.pin}
                    onChange={handleInputChange}
                    size="small"
                    sx={{ marginTop: 1 }}
                    fullWidth
                    placeholder="PIN Code"
                    inputProps={{ inputMode: "numeric" }}
                  />
                </FormControl>

                {/* Website */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">Website URL</Typography>
                  <TextField
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Enter website"
                    fullWidth
                  />
                </FormControl>

                {/* Branches */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">Branches (if any)</Typography>
                  <TextField
                    name="branches"
                    value={formData.branches}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Enter branch details if any"
                    fullWidth
                  />
                </FormControl>

                {/* FSSAI */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    FSSAI License No. <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="fssai"
                    value={formData.fssai}
                    onChange={handleInputChange}
                    size="small"
                    inputProps={{ inputMode: "numeric", maxLength: 14 }}
                    placeholder="Enter FSSAI number (Min 14 digits)"
                    fullWidth
                  />
                </FormControl>

                {/* FSSAI Upload */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    FSSAI Certificate (Image or PDF, Max 2MB){" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Button variant="outlined" component="label" fullWidth>
                    Upload Certificate
                    <input
                      hidden
                      type="file"
                      accept=".jpg,.jpeg,.png,.webp,.pdf"
                      onChange={handleFssaiUpload}
                    />
                  </Button>
                  {fssaiFile && (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt={1}
                    >
                      <Typography variant="body2">
                        {typeof fssaiFile === "string"
                          ? fssaiFile.split("/").pop()
                          : fssaiFile.name}
                      </Typography>
                      <Box>
                        <IconButton
                          onClick={() => {
                            if (typeof fssaiFile === "string") {
                              // If already URL from backend
                              window.open(fssaiFile, "_blank");
                            } else {
                              // If newly uploaded file
                              window.open(
                                URL.createObjectURL(fssaiFile),
                                "_blank",
                              );
                            }
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                        <IconButton onClick={() => setFssaiFile(null)}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                </FormControl>

                {/* Kitchen Images */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Kitchen Images (max 3, each ≤ 2MB)
                  </Typography>
                  <Button variant="outlined" component="label" fullWidth>
                    Upload Kitchen Images
                    <input
                      hidden
                      type="file"
                      multiple
                      onChange={handleKitchenImagesUpload}
                    />
                  </Button>
                  <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
                    {Array.isArray(kitchenImages) &&
                      kitchenImages.map((img, i) => {
                        const imageSrc =
                          typeof img === "string"
                            ? img
                            : URL.createObjectURL(img);
                        return (
                          <Box
                            key={i}
                            sx={{ position: "relative", width: 80, height: 80 }}
                          >
                            <img
                              src={imageSrc}
                              alt={`kitchen-${i}`}
                              width="80"
                              height="80"
                              style={{ objectFit: "cover", borderRadius: 4 }}
                            />
                            <Box
                              sx={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                background: "rgba(255,255,255,0.8)",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <IconButton
                                onClick={() => {
                                  if (typeof img === "string") {
                                    // remove URL entry
                                    setKitchenImages((prev) =>
                                      prev.filter((_, idx) => idx !== i),
                                    );
                                  } else {
                                    // remove local file entry
                                    removeKitchenImage(i);
                                  }
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        );
                      })}
                  </Box>
                </FormControl>

                {/* Menu Upload */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">Menu List (Max 2MB)</Typography>
                  <Button variant="outlined" component="label" fullWidth>
                    Upload Menu List
                    <input hidden type="file" onChange={handleMenuUpload} />
                  </Button>
                  {menuFile && (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt={1}
                    >
                      <Typography variant="body2">
                        {typeof menuFile === "string"
                          ? menuFile.split("/").pop()
                          : menuFile.name}
                      </Typography>
                      <Box>
                        <IconButton
                          onClick={() => {
                            if (typeof menuFile === "string") {
                              window.open(menuFile, "_blank");
                            } else {
                              window.open(
                                URL.createObjectURL(menuFile),
                                "_blank",
                              );
                            }
                          }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                        <IconButton onClick={() => setMenuFile(null)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                </FormControl>

                {/* PAN & GST */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    PAN Number (Min 10 Alphanumeric)
                  </Typography>
                  <TextField
                    name="pan"
                    value={formData.pan}
                    onChange={handleInputChange}
                    size="small"
                    inputProps={{ inputMode: "text", maxLength: 10 }}
                    placeholder="Enter PAN Number"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    GSTIN (Min 15 Alphanumeric){" "}
                  </Typography>
                  <TextField
                    name="gst"
                    value={formData.gst}
                    onChange={handleInputChange}
                    inputProps={{ inputMode: "text", maxLength: 15 }}
                    size="small"
                    placeholder="Enter GST Number"
                  />
                </FormControl>

                {/* Interested To Do */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Interested to do <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
                    {[
                      "Corporate Catering Service",
                      "Industrial Catering Service",
                      "Outdoor Catering Services / Events",
                      "Food Court / Pantry Setup",
                      "OTHERS",
                    ].map((val) => (
                      <FormControlLabel
                        key={val}
                        control={
                          <Checkbox
                            checked={formData.interestedServices.includes(val)}
                            onChange={(e) => {
                              if (val === "OTHERS" && !e.target.checked)
                                setOtherService("");
                              setFormData((prev) => ({
                                ...prev,
                                interestedServices: e.target.checked
                                  ? [...prev.interestedServices, val]
                                  : prev.interestedServices.filter(
                                      (v) => v !== val,
                                    ),
                              }));
                            }}
                          />
                        }
                        label={val}
                      />
                    ))}
                  </Box>

                  {formData.interestedServices.includes("OTHERS") && (
                    <TextField
                      size="small"
                      fullWidth
                      sx={{ mt: 1 }}
                      placeholder="Please specify other services"
                      value={otherService}
                      onChange={(e) => setOtherService(e.target.value)}
                    />
                  )}
                </FormControl>

                {/* Referral */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    Referral Person Name
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      name="referralFirst"
                      value={formData.referralFirst}
                      onChange={handleInputChange}
                      size="small"
                      placeholder="First Name"
                      fullWidth
                    />
                    <TextField
                      name="referralLast"
                      value={formData.referralLast}
                      onChange={handleInputChange}
                      size="small"
                      placeholder="Last Name"
                      fullWidth
                    />
                  </Box>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">
                    QHSC Auditor Name
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    name="qhscauditor"
                    value={formData.qhscauditor}
                    onChange={handleInputChange}
                    size="small"
                    placeholder="Enter name"
                    fullWidth
                  />
                </FormControl>
                {!vendorId && (
                  <>
                    {/* Terms */}
                    <FormControl fullWidth sx={{ mt: 2 }}>
                      <Typography variant="subtitle2">
                        Terms and Conditions{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Box
                        onClick={() =>
                          window.open(
                            "https://workdrive.zohopublic.in/file/i8ckz6b835d822a9a4bf187762c9d9e0cc931",
                            "_blank",
                          )
                        }
                        sx={{
                          border: "1px solid #999",
                          p: 2,
                          mb: 1,
                          cursor: "pointer",
                          borderRadius: "4px",
                        }}
                      >
                        VENDOR AGREEMENT DOCUMENT
                      </Box>
                      <FormControlLabel
                        control={<Checkbox required />}
                        label="I hereby confirm that all the above-provided information is true. I have read and understood the Vendor Agreement, and I fully accept and agree to all the terms and conditions outlined therein, as well as the general Terms and Conditions."
                      />
                    </FormControl>

                    {/* Signature */}
                    <FormControl fullWidth sx={{ mt: 3 }}>
                      <Typography variant="subtitle2">
                        Signature <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Tabs
                        value={signatureMode}
                        onChange={(e, val) => {
                          setSignatureMode(val);
                          clearSignature();
                        }}
                        sx={{ mb: 2 }}
                      >
                        <Tab value="draw" label="Draw Signature" />
                        <Tab value="type" label="Type Signature" />
                      </Tabs>

                      {signatureMode === "draw" ? (
                        <Box
                          sx={{
                            position: "relative",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            background: "#fff",
                            width: "100%",
                            overflow: "hidden",
                          }}
                        >
                          <SignatureCanvas
                            ref={sigCanvas}
                            penColor="black"
                            onEnd={handleSignatureEnd}
                            clearOnResize={false}
                            backgroundColor="white"
                            canvasProps={{
                              width: "100%",
                              height: 180,
                              style: {
                                width: "100%",
                                height: "180px",
                                display: "block",
                                touchAction: "none",
                              },
                            }}
                          />
                          <IconButton
                            onClick={clearSignature}
                            size="small"
                            sx={{
                              position: "absolute",
                              top: 5,
                              right: 5,
                              background: "rgba(255,255,255,0.8)",
                              "&:hover": { background: "rgba(255,255,255,1)" },
                            }}
                          >
                            <DeleteIcon fontSize="small" color="error" />
                          </IconButton>
                        </Box>
                      ) : (
                        <Box sx={{ position: "relative" }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Type your name as signature"
                            value={typedSignature}
                            onChange={(e) => setTypedSignature(e.target.value)}
                          />
                          {typedSignature && (
                            <IconButton
                              onClick={clearSignature}
                              size="small"
                              sx={{
                                position: "absolute",
                                right: 5,
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "rgba(255,255,255,0.8)",
                              }}
                            >
                              <DeleteIcon fontSize="small" color="error" />
                            </IconButton>
                          )}
                        </Box>
                      )}
                    </FormControl>
                  </>
                )}

                {/* Submit */}
                <FormControl fullWidth sx={{ mt: 4 }}>
                  <Button
                    variant="contained"
                    type="submit"
                    size="large"
                    fullWidth
                    disabled={loading}
                    startIcon={
                      loading && <CircularProgress size={20} color="inherit" />
                    }
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button>
                </FormControl>

                <Box sx={{ textAlign: "center", mt: 5, color: "text.secondary" }}>
                  <Typography variant="body2">
                    Powered by{" "}
                    <Typography
                      component="span"
                      color="primary"
                      fontWeight="bold"
                    >
                      HOGIST
                    </Typography>{" "}
                    © {new Date().getFullYear()} All Rights Reserved
                  </Typography>
                </Box>
              </Box>
              {/* --------------- FORM END --------------- */}
            </Paper>
          </Container>

          {/* Snackbar */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={4000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setSnackbar({ ...snackbar, open: false })}
              severity={snackbar.severity}
              variant="filled"
            > 
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Box>
      </ThemeProvider>
    );
  }
